//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "loading",
  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/loading.vue